import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useLanguage } from '../context/LanguageContext';

const FAQSection = () => {
  const { t } = useLanguage();

  return (
    <section id="faq" className="bg-[#1a1c1b] py-20 md:py-28 border-t border-[#3f4816]/30">
      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-12">
          <h2 className="font-black text-[#d9fb06] text-3xl sm:text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.85]">
            {t.faq.title}
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl">
          <Accordion type="single" collapsible className="space-y-4">
            {t.faq.items.map((item) => (
              <AccordionItem
                key={item.id}
                value={item.id}
                className="border border-[#3f4816]/50 bg-[#302f2c]/20 px-5 md:px-6 rounded-none data-[state=open]:border-[#d9fb06]/30"
              >
                <AccordionTrigger className="text-[#d9fb06] text-left font-semibold text-base md:text-lg py-5 md:py-6 hover:no-underline hover:text-[#d9fb06]/80 [&[data-state=open]>svg]:text-[#d9fb06]">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#888680] text-sm md:text-base leading-relaxed pb-5 md:pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
